import { useMemo } from 'react';
import { encode } from 'uqr';

export interface TotpQrCodeProps {
  /** The `otpauth://` URI an authenticator app scans. */
  uri: string;
  label: string;
}

/** A QR code drawn as one SVG path, so it stays crisp at any size. */
export const TotpQrCode = ({ uri, label }: TotpQrCodeProps) => {
  const { size, path } = useMemo(() => {
    const qr = encode(uri, { ecc: 'M', border: 2 });
    const cells = qr.data.flatMap((row, y) =>
      row.flatMap((dark, x) => (dark ? [`M${x} ${y}h1v1h-1z`] : []))
    );
    return { size: qr.size, path: cells.join('') };
  }, [uri]);

  return (
    <svg
      className="sign-in__qr"
      viewBox={`0 0 ${size} ${size}`}
      role="img"
      aria-label={label}
      shapeRendering="crispEdges"
    >
      {/* Always dark on white: authenticator apps can't read an inverted code. */}
      <rect width={size} height={size} fill="#fff" />
      <path d={path} fill="#000" />
    </svg>
  );
};
